import { AuthInfo, BadgeUpdate, EventEditionDetails, IPersonBadge } from "../../types";
import MagentoHelper from "../../network/helpers/magento/MagentoHelper";
import { CustomerTypes } from "../../../components/createBadge/enums/CustomerTypes";
import { BadgePaymentStatus, BadgeStatuses, PaymentMethods } from "../../enums";

class BadgeHelper {
  getUpdateBadgeDto(
    badge: IPersonBadge,
    eventEdition: EventEditionDetails,
    options: AuthInfo,
    orderId?: string
  ): BadgeUpdate {
    const {
      id: badgeId,
      contact,
      customerType,
      organisation: { displayName, city, state, countryCode },
      supportStaffDetails: { companyName, stands, reportsTo, companyAddress, userAccess, mobilePhone }
    } = badge;
    const { primaryLocale } = eventEdition;
    const dto: BadgeUpdate = {
      badgeId,
      organisation: { displayName, city, state, countryCode },
      contact: {
        firstName: contact.firstName,
        lastName: contact.lastName,
        jobTitle: contact.jobTitle,
        mobilePhone: contact.mobilePhone
      },
      customerType,
      store: MagentoHelper.getStoreHeader(eventEdition, primaryLocale!),
    } as BadgeUpdate;

    if (orderId) {
      dto.orderId = orderId;
    }

    const userAccessValue = userAccess || null;
    const access = options.isUserAdmin ? userAccessValue : null;

    if (customerType === CustomerTypes.STAFF || customerType === CustomerTypes.CONTRACTOR) {
      dto.supportStaffDetails = {
        companyName,
        companyAddress,
        reportsTo: reportsTo || "",
        stands: stands || "",
        userAccess: access,
        mobilePhone: mobilePhone || ""
      };
    }
    return dto;
  }

  isBadgeActive(status: BadgeStatuses) {
    return status === BadgeStatuses.ACTIVE;
  }

  isBadgePending(status: BadgeStatuses) {
    return status === BadgeStatuses.PENDING;
  }

  isBadgeRejected(status: BadgeStatuses) {
    return status === BadgeStatuses.REJECTED;
  }

  isBadgeCancelled(status: BadgeStatuses) {
    return status === BadgeStatuses.CANCELLED;
  }

  isBadgeInactive(status: BadgeStatuses) {
    return status === BadgeStatuses.INACTIVE;
  }

  isDelegateBadge(badge: IPersonBadge) {
    return badge.customerType === CustomerTypes.EXHIBITING_DELEGATE;
  }

  getFullBadgeStatusFlags(status: BadgeStatuses) {
    return {
      isBadgeActive: this.isBadgeActive(status),
      isBadgePending: this.isBadgePending(status),
      isBadgeInactive: this.isBadgeInactive(status),
      isBadgeCancelled: this.isBadgeCancelled(status),
      isBadgeRejected: this.isBadgeRejected(status),
    }
  }

  getBadgePaymentStatusAfterUpgrade(badge: IPersonBadge, paymentMethod: PaymentMethods | string | undefined) {
    if (!paymentMethod) {
      return badge.paymentStatus;
    }

    if (paymentMethod === PaymentMethods.FREE) {
      return BadgePaymentStatus.FREE;
    }
    if (paymentMethod === PaymentMethods.BANK_TRANSFER) {
      return BadgePaymentStatus.UNPAID;
    }
    return BadgePaymentStatus.PAID;
  }
}

export default new BadgeHelper();
